'use client';

import React from 'react';
import Link from 'next/link';
import useEmblaCarousel from 'embla-carousel-react';
import { EmblaOptionsType } from 'embla-carousel';
import { NextButton, PrevButton, usePrevNextButtons } from './EmblaCarouselArrowButton';
import { DotButton, useDotButton } from './EmblaCarouselDotButton';
import './css/carousel.css';

type Operator = {
  id: number;
  slug: string;
  name: string;
  icon: string;
  profileUrl?: string;
};

type PropType = {
  operators: Array<Operator>;
  options?: EmblaOptionsType;
};

export const OperatorsCarousel: React.FC<PropType> = (props) => {
  const { operators, options } = props;
  const [emblaRef, emblaApi] = useEmblaCarousel(options);

  const { selectedIndex, scrollSnaps, onDotButtonClick } = useDotButton(emblaApi);

  const { prevBtnDisabled, nextBtnDisabled, onPrevButtonClick, onNextButtonClick } = usePrevNextButtons(emblaApi);

  return (
    <div className="embla operators-embla mt-auto lg:-mt-12">
      <div className="embla__controls">
        <div className="embla__buttons">
          <PrevButton onClick={onPrevButtonClick} disabled={prevBtnDisabled} />
          <NextButton onClick={onNextButtonClick} disabled={nextBtnDisabled} />
        </div>
      </div>

      <div className="embla__viewport" ref={emblaRef}>
        <div className="embla__container operators-container">
          {operators.map((operator) => (
            <div key={operator.id} className="embla__slide operators-slide">
              {operator.profileUrl ? (
                <Link href={operator.profileUrl} className="operator-item block">
                  <img src={operator.icon} alt={operator.name} loading="lazy" />
                  <span>{operator.name}</span>
                </Link>
              ) : (
                <div className="operator-item block">
                  <img src={operator.icon} alt={operator.name} loading="lazy" />
                  <span>{operator.name}</span>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>

      <div className="embla__dots">
        {scrollSnaps.map((_, index) => (
          <DotButton
            key={index}
            onClick={() => onDotButtonClick(index)}
            className={'embla__dot'.concat(index === selectedIndex ? ' embla__dot--selected' : '')}
          />
        ))}
      </div>
    </div>
  );
};

export default OperatorsCarousel;

